var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.34 185.84"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".logo_svg__cls-1{fill:#cff200}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__cls-1",
    d: "M115.53 185.84V70.31L0 185.84h115.53M55.05 0v115.53L170.58 0H55.05M168.56 154.26c-3.55-7.43-11.13-12.56-19.92-12.56-12.19 0-22.07 9.88-22.07 22.07s9.88 22.07 22.07 22.07h35.7l-15.79-31.57Z"
  }))));
};
export default SvgLogo;